import { useEffect, useState } from 'react'
import { Input } from 'antd'
import { getRepeatCount } from '../helpers'
import withRepeater from './withRepeater'
import { isValidNamespaceUrl } from 'Services/WeaverUtils'

SequencedFormStringInput = ({
  form,
  formItem,
  config = {},
  loading,
  queries,
  label,
  nodeId,
  props... }) ->

  <Input
    { props... }
    allowClear
    disabled={config?.disabled}
    placeholder={if isValidNamespaceUrl(formItem) then formItem else _.startCase(formItem)}
  />

export default withRepeater(SequencedFormStringInput)
